<template>
<div class="chapter">
<div class="inner_page">
<div id="x9781590207048-5.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<h1 class="Chapter_Number" id="toc_marker-6">PREFACE</h1>
<p class="Opening-Para">“The style is the man,” once said Richard Nixon and devoted his life to boring his readers.</p>
<p class="Body-Text">What to do if there is no single man? Should the style vary as the man <span class="Italic">writing</span> the autobiography varies, or as the past man he writes about varied? Literary critics would declare that the style of a chapter should correspond to the man whose life is being dramatized: a quite rational injunction, one that ought therefore to be repeatedly disobeyed. The comic life portrayed by Hamlet, everyday kitchen events being described by Churchill, the man in love described by an Einstein. Thus it will have to be. Let us have no more quibbles about style. If style and subject matter happen to congeal in any of these chapters it is a lucky accident, not, we may hope, soon to be repeated.</p>
<p class="Body-Text">A cunning chaos: that is what my autobiography shall be. I shall make my order chronological, an innovation dared these days by few. But my style shall be random, with the wisdom of the Die. I shall sulk and soar, extol and sneer. I shall shift from first person to third person: I shall use first-person omniscient, a mode of narrative generally reserved for Another. When distortions and digressions occur to me in my life’s history I shall embrace them, for a well-told lie is a gift of the gods. But the realities of the Dice Man’s life are more entertaining than my most inspired fictions: reality will dominate—for its entertainment value.</p>
<p class="Body-Text">I tell my life’s story for that humble reason which has inspired every user of the form: to prove to the world I am a great man. I shall fail, of course, like the others. “To be great is to be misunderstood,” Elvis Presley once said, and no one can refute him. I tell of a man’s instinctive attempt to fulfill himself in a new way and I will be judged insane. So be it. Were it otherwise, I would fear I had failed.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781590207048-5.vue?38b67d93